export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '神目AI开放平台',
  /**
   * @description 神目官网地址
   */
  href: 'https://www.deepcam.cn/',
  /**
   * @description Cookie中存储的天数，默认1天
   */
  expires: 1,
  /**
   * @description 是否使用国际化，默认为false
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://192.168.7.171:8000',
    pro: (window.location.origin || (window.location.protocol + "//" + window.location.host)) + '/mgt'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js